import { useEffect } from 'react';
import { jsx } from '@emotion/core';
import { BlockPanel, FormLabelGroup, Combobox } from '@appfolio/react-gears';
import { observer } from 'mobx-react';
import useStores from "../../../hooks/useStores.js";
import { textFontSizeOptions } from "../textUtils.js";
import { isMobileView } from "../../layoutUtils.js";

var FillableFieldProperties = function FillableFieldProperties() {
  var _pdfStore$selectedFie, _pdfStore$selectedFie3, _pdfStore$selectedFie4, _pdfStore$selectedFie5;

  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore;

  var valueType = (_pdfStore$selectedFie = pdfStore.selectedField) === null || _pdfStore$selectedFie === void 0 ? void 0 : _pdfStore$selectedFie.data.valueType;
  var titleFor = {
    signature: 'Signature',
    initials: 'Initials',
    boolean: 'Checkbox',
    string: 'Text',
    date: 'Text'
  };
  useEffect(function () {
    // Only set fontSizeOptions for text fields here. Signature field font size
    // options are set in FillableSignatureField component after the signature
    // value has been set and the max font size has been calculated.
    if (!pdfStore.selectedField || pdfStore.selectedField.data.dataType !== 'manual') {
      return;
    }

    var options = textFontSizeOptions(pdfStore.selectedField);
    pdfStore.selectedField.setFontSizeOptions(options);
  }, [pdfStore.selectedField]);

  var handleFontSizeChange = function handleFontSizeChange(fontSize) {
    if (fontSize && typeof fontSize === 'number') {
      var _pdfStore$selectedFie2;

      (_pdfStore$selectedFie2 = pdfStore.selectedField) === null || _pdfStore$selectedFie2 === void 0 ? void 0 : _pdfStore$selectedFie2.updateData({
        fontSize: fontSize
      });
    }
  };

  var hasFieldProperties = valueType && valueType !== 'boolean';
  var noFieldPropertiesMessage = pdfStore.selectedField ? 'There are currently no customizable properties available for checkboxes.' : 'No field is selected.';
  return jsx(BlockPanel, {
    title: valueType && "Edit ".concat(titleFor[valueType], " Field") || 'Select a field to edit',
    expandable: isMobileView(),
    open: !isMobileView()
  }, hasFieldProperties ? jsx(FormLabelGroup, {
    label: "Font Size",
    stacked: true
  }, jsx(Combobox, {
    value: (_pdfStore$selectedFie3 = pdfStore.selectedField) === null || _pdfStore$selectedFie3 === void 0 ? void 0 : _pdfStore$selectedFie3.fontSize,
    options: (_pdfStore$selectedFie4 = (_pdfStore$selectedFie5 = pdfStore.selectedField) === null || _pdfStore$selectedFie5 === void 0 ? void 0 : _pdfStore$selectedFie5.fontSizeOptions) !== null && _pdfStore$selectedFie4 !== void 0 ? _pdfStore$selectedFie4 : [],
    onChange: handleFontSizeChange
  })) : jsx("p", {
    className: "text-center font-italic"
  }, noFieldPropertiesMessage));
};

FillableFieldProperties.displayName = "FillableFieldProperties";
var FillableFieldProperties$1 = observer(FillableFieldProperties);
export default FillableFieldProperties$1;